import { z } from "zod";

export const DetailPageEntitySchema = z.object({
  id: z.number(),
  imageUrl: z.string(),
  displayOrder: z.number(),
});

export type DetailPageEntity = z.infer<typeof DetailPageEntitySchema>;

export const PriceTierEntitySchema = z.object({
  id: z.number(),
  minQuantity: z.number(),
  maxQuantity: z.number().optional().nullable(),
  price: z.number(),
});

export type PriceTierEntity = z.infer<typeof PriceTierEntitySchema>;

export const ProductEntitySchema = z.object({
  id: z.number(),
  companyId: z.number(),
  categoryId: z.number(),
  name: z.string(),
  description: z.string().optional().nullable(),
  thumbnail: z.string().optional().nullable(),
  detailPage: z.array(DetailPageEntitySchema).optional().nullable(),
  isBestSeller: z.boolean(),
  priceTiers: z.array(PriceTierEntitySchema).optional().nullable(),
  createdAt: z.string(),
  updatedAt: z.string().optional().nullable(),
  isQuoteOnly: z.boolean().optional(),
});

export type ProductEntity = z.infer<typeof ProductEntitySchema>;

export const ProductCategoryEntitySchema = z.object({
  id: z.number(),
  companyId: z.number(),
  name: z.string(),
  createdAt: z.string(),
  updatedAt: z.string().nullable().optional(),
  products: z.array(ProductEntitySchema),
});

export type ProductCategoryEntity = z.infer<typeof ProductCategoryEntitySchema>;

export const GetProductsResponseSchema = z.object({
  categories: z.array(ProductCategoryEntitySchema),
});

export type GetProductsResponse = z.infer<typeof GetProductsResponseSchema>;

export const DetailPageDtoSchema = z.object({
  id: z.number(),
  imageUrl: z.string().nullable().optional(),
  displayOrder: z.number(),
});

type DetailPageDto = z.infer<typeof DetailPageDtoSchema>;

export const QuantityApplyTypeSchema = z.enum(["SINGLE", "MULTIPLE", "SELECTABLE"])

export type QuantityApplyType = z.infer<typeof QuantityApplyTypeSchema>

export const ProductOptionSettingEntitySchema = z.object({
  optionId: z.number(),
  isRequired: z.boolean(),
  quantityApplyType: QuantityApplyTypeSchema,
  isBasedOnSizeOption: z.boolean(),
  isMultiOption: z.boolean(),
});